import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    operatorUserId: "",
    dateFrom:"",
  };
  
  const operatorReportSlice = createSlice({
    name: 'operatorReport',
    initialState,
    reducers: {
      setOperatordData: (state, action) => {
        state.operatorUserId = action.payload.operatorUserId;
        state.dateFrom = action.payload.dateFrom;
        state.dateTo = action.payload.dateTo;
      },
    },
  });
  
  export const { setOperatordData } = operatorReportSlice.actions;
  export default operatorReportSlice.reducer;